export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            有影视资源推荐或合作意向？欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 text-center">
            <div className="group cursor-pointer">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-heading text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">business@nongminmovie.tv</p>
            </div>

            <div className="group cursor-pointer">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-chat-1-line text-xl"></i>
              </div>
              <h3 className="text-sm font-heading text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">submit@nongminmovie.tv</p>
            </div>

            <div className="group cursor-pointer">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-question-answer-line text-xl"></i>
              </div>
              <h3 className="text-sm font-heading text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">support@nongminmovie.tv</p>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-background-200">
            <p className="text-xs text-foreground-500 text-center leading-relaxed">
              我们重视每一位用户的反馈和建议。如需推荐影视作品或报告播放问题，请通过以上邮箱联系我们，团队将在 24 小时内回复处理。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}